import React from "react";
import { Modal, Button, Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4
};

const ConfirmationModal = ({section, show, content, closeHandler, deleteHandler }) => {
	return (
		<Modal
			open={show}
			onClose={() => closeHandler(false)}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box sx={style}>
				<Typography id="modal-modal-title" variant="h6" component="h2">
				Delete {section}
				</Typography>
				<Typography id="modal-modal-description" sx={{ mt: 2 }}>
					Are you sure you want to delete this {section}?
					<p><b>{section}</b> : {content}</p>
				</Typography>
				<div className="margin">
					<Button variant='contained' onClick={deleteHandler}>Delete {section}</Button>
					<Button variant='contained'
						onClick={() => closeHandler(false)}
						style={{marginLeft: "10px"}}>Cancel</Button>
				</div>
			</Box>
		</Modal>
	);
};

ConfirmationModal.propTypes = {
	section: PropTypes.string,
	show: PropTypes.bool,
	content: PropTypes.string,
	closeHandler: PropTypes.func,
	deleteHandler: PropTypes.func
};

ConfirmationModal.defaultProps = {
	section: "",
	show: false,
	content: "",
	closeHandler: null,
	deleteHandler: null
};

export default ConfirmationModal;
